'use client';
var classes = {"root":"m_cd2bd9e5","tooltip":"m_6bcc3420"};

export { classes as default };
//# sourceMappingURL=RadialBarChart.module.css.mjs.map
